import { ContinueButton } from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import { gsap } from "gsap";
import { Container } from "pixi.js";

import { AbstractView } from "../AbstractView";

export class AbstractScreen extends Container {
    protected parentContainer: AbstractView;
    protected continueButton: ContinueButton;

    constructor(name: string, parentContainer: AbstractView) {
        super();

        this.name = name;
        this.parentContainer = parentContainer;

        this.init();
    }

    protected init(): void {
        this.continueButton = new ContinueButton();
    }

    public getGsapAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, { paused: true });
    }

    public onContinueBtnClick: Function = () => {};

    protected selfRemoveFromParent(): void {
        this.parentContainer?.removeChild(this);
    }

    protected selfAddToParent(): void {
        this.parentContainer?.addChild(this);
    }

    public start(onClick: Function): void {
        this.onContinueBtnClick = onClick;
    }

    public onOrientationChange(): void {}

    public show(): void {
        this.selfAddToParent();
    }
}
